import { ActionsPage } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->

  (await ActionsPage.list({ transaction }))
    .filter((service) -> service.get('service')?)
    .map((service) ->
      oldConf = JSON.parse(service.get('service'))
      service
        .set('serviceName', oldConf.name)
        .set('serviceCall', oldConf.call)
        .set('parameters',
          {
            config: oldConf.config
            profile: oldConf.staticArgs?[0]
          }, { dataType: 'json' }
        ).unset('service')
        .save({ transaction, branch })
    )
